module.exports = __webpack_public_path__ + "static/media/bg_4k.07ee1b60.svg";